import type * as q from "./queries.ts";

/** Collapse whitespace and truncate to a code-point budget for titles and descriptions. */
export function excerpt(text: string, max: number): string {
  const collapsed = text.replace(/\s+/g, " ").trim();
  const points = [...collapsed];
  return points.length > max ? `${points.slice(0, max).join("").trimEnd()}…` : collapsed;
}

export function profileTitle(actor: q.ActorView): string {
  if (actor.handle) {
    return actor.displayName
      ? `${actor.displayName} (@${actor.handle}) - Cerulea`
      : `@${actor.handle} - Cerulea`;
  }
  return `${actor.displayName ?? actor.did} - Cerulea`;
}

export function postTitle(post: q.PostView): string {
  const author = post.author.handle ? `@${post.author.handle}` : post.author.did;
  const text = excerpt(post.record.text, 140);
  return text ? `${author}: ${text} - Cerulea` : `${author} - Cerulea`;
}
